/* global Linear */
import merge from 'lodash/merge';
import clone from 'lodash/clone';
import fluxDefaults from './defaults';

module.exports = merge(clone(fluxDefaults, true), {
    // particleScale: 0.6,
    // particlesRadius: 0.07,
    initialTicks: 30,
    walls: [
        // left
        {
            x: '-12%',
            y: '-26%',
            offsetX: -16,
            width: 20,
            height: '103%',
        },
        // right
        {
            x: '102%',
            y: '-50%',
            width: 20,
            height: '300%',
        },
        // bottom
        {
            x: '-30%',
            y: '86%',
            width: '140%',
            height: 20,
        },
        // elevator-border-left
        {
            x: '-30%',
            y: '-200%',
            width: 20,
            height: '300%',
        },
        // elevator-top-kicker
        {
            x: '-50%',
            y: '-60%',
            width: '110%',
            height: 20,
            angle: -50,
        },
        // elevator-bottom-safe
        {
            x: '-14%',
            y: '76%',
            width: '10%',
            height: 20,
            angle: 30,
        },
        // top angle
        {
            x: '-6%',
            y: '-29%',
            width: '120%',
            height: 20,
            angle: -30,
        },
        // top angle wall
        {
            x: '35%',
            y: '-80%',
            width: 20,
            height: '58%',
        },
        // entrance - wall
        {
            x: '-2%',
            y: '-12%',
            width: 20,
            height: '28%',
            angle: 8,
        },
        // entrance - corner left
        {
            x: '-14%',
            y: '27%',
            width: '10%',
            height: 20,
            angle: 30,
        },
        // entrance - corner right
        {
            x: '-8%',
            y: '27%',
            width: '6%',
            height: 20,
            angle: -20,
        },
    ],
    movingWalls: [
        {
            x: '-30%',
            y: '100%',
            width: '18%',
            height: 20,
            angle: 45,
            tween: {
                y: '-50%',
                duration: 3,
                ease: Linear.easeNone,
                repeat: -1,
            },
        },
        {
            x: '-30%',
            y: '100%',
            width: '18%',
            height: 20,
            angle: 45,
            tween: {
                y: '-50%',
                duration: 3,
                ease: Linear.easeNone,
                delay: 0.75,
                repeat: -1,
            },
        },
        {
            x: '-30%',
            y: '100%',
            width: '18%',
            height: 20,
            angle: 45,
            tween: {
                y: '-50%',
                duration: 3,
                ease: Linear.easeNone,
                delay: 1.5,
                repeat: -1,
            },
        },
        {
            x: '-30%',
            y: '100%',
            width: '18%',
            height: 20,
            angle: 45,
            tween: {
                y: '-50%',
                duration: 3,
                ease: Linear.easeNone,
                delay: 2.25,
                repeat: -1,
            },
        },
    ],
    blobs: [
        // main
        {
            x: '0%',
            y: '50%',
            width: '30%',
            height: '36%',
            color: [0, 0, 0, 255],
        },
        {
            x: '30%',
            y: '50%',
            width: '10%',
            height: '36%',
            color: [0, 255, 0, 255],
        },
        {
            x: '40%',
            y: '50%',
            width: '10%',
            height: '36%',
            color: [0, 255, 0, 255],
        },
        {
            x: '50%',
            y: '50%',
            width: '50%',
            height: '36%',
            color: [0, 0, 255, 255],
        },

        // starter
        {
            x: '-10%',
            y: '-40%',
            width: '20%',
            height: '20%',
            color: [0, 0, 0, 255],
        },
        {
            x: '10%',
            y: '-50%',
            width: '10%',
            height: '20%',
            color: [255, 0, 0, 255],
        },
        {
            x: '20%',
            y: '-50%',
            width: '10%',
            height: '20%',
            color: [0, 0, 0, 255],
        },

        // elevator
        {
            x: '-25%',
            y: '0%',
            width: '8%',
            height: '40%',
            color: [0, 0, 0, 255],
        },
        {
            x: '-25%',
            y: '40%',
            width: '8%',
            height: '40%',
            color: [255, 0, 0, 255],
        },
    ],
});



// WEBPACK FOOTER //
// ./js/flux/bucketFullFrame.js